/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";
import { Helmet } from "react-helmet";
import style from "./index.module.scss";
import cookieUtil from "@/utils/cookieUtils";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CreatePasswordDom from "./components/forgotPassword";
import UKToast from "@/common-components-src/components/UKToast/index";;
import { retrievePasswordApi } from "@/app/csr-src/apis/resetPassword/resetPassword.api";
import { getCurrentRouteParams, getEncryptDefaultString } from "@/app/csr-src/utils/helpers";
import withHeaderFooter, { IWithHeaderFooterProps } from "@/app/csr-src/hocs/with-header-footer";

const ForgotPassword = withHeaderFooter(({ JDIHeader }: IWithHeaderFooterProps) => {
  const navigate = useNavigate();
  const _email: string = cookieUtil.getCookie("_lsa") || "";
  const [_stepCode, setStepCode] = useState<string>("");

  useEffect(() => {
    const { showRememberMe, prePopuLatedStepCode } = getCurrentRouteParams();
    // 如果不是从忘记密码页面过来的 返回到首页
    if (!showRememberMe) {
      window.location.href = "/";
      return;
    }
    // 设置 stepCode
    if (prePopuLatedStepCode) {
      setStepCode(prePopuLatedStepCode);
    }
  }, []);
  // 确认修改重置密码
  const onSubmit = async (password: string) => {
    try {
      const [err, res]: any = await retrievePasswordApi({
        password: getEncryptDefaultString(password) as string,
        stepCode: _stepCode,
        otpType: 3,
      });
      if (err) {
        UKToast.show({
          content: res?.msg,
          icon: "error",
        });
        return;
      }
      if (res && res.success) {
        cookieUtil.setUserCookie("_lsa", _email, 15);
        cookieUtil.clearSessionStorage("_email");
        navigate("/password-changed", { replace: true });
      } else {
        UKToast.show({
          content: res?.msg,
          icon: "error",
        });
      }
      // eslint-disable-next-line no-empty
    } catch (error) {
      console.log("error:", error);
    }
  };
  // 最后点击 Continue

  return (
    <div className={style.resetPasswordWrap}>
      <Helmet>
        <title>Reset Your Password | Joybuy</title>
        <meta
          name="description"
          content="Forgot your password? Reset it easily and securely at Joybuy.com. Once logged in, enjoy fast shipping and a delivery guarantee on all orders."
        />
      </Helmet>
      <CreatePasswordDom onSubmit={onSubmit} />
    </div>
  );
});

export default ForgotPassword;
